document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('#shopify-block-ARmlmMHpHZEM4TWpwY__forms_inline_WKrQNh');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('form-embed');

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();
      // Split into separate rules for proper parsing
      sheet.insertRule('._formContainer_stahb_30 { max-width: 600px !important; margin: 0 auto !important; overflow: visible !important; }');
      sheet.insertRule('form { gap: 20px !important; padding: 2px !important; }');
      sheet.insertRule('form > *:nth-child(7), form > *:nth-child(18), form > *:nth-child(22), form > *:nth-child(25) { margin-top: 50px !important; }');
      sheet.insertRule('form > *:nth-child(13) { margin-top: 20px !important; }');
      sheet.insertRule('form h2, form h3 { margin: 0px !important; }');
      sheet.insertRule('._appEmbed_3eyaa_1[data-current-step="success"] { text-align: center !important; }');
      shadow.adoptedStyleSheets.push(sheet);


      // INSERTING HEADINGS
      const customerInfoHeading = document.createElement('h2');
      customerInfoHeading.textContent = 'Customer Information';
      shadow.querySelector('form > *:nth-child(1)').before(customerInfoHeading);

      const productDetailsHeading = document.createElement('h2');
      productDetailsHeading.textContent = 'Product Details';
      shadow.querySelector('form > *:nth-child(6)').after(productDetailsHeading);

      const itemOneHeading = document.createElement('h3');
      itemOneHeading.textContent = 'Item 1';
      shadow.querySelector('form > *:nth-child(7)').after(itemOneHeading);

      const itemTwoHeading = document.createElement('h3');
      itemTwoHeading.textContent = 'Item 2';
      shadow.querySelector('form > *:nth-child(12)').after(itemTwoHeading);

      const returnClaimDetailsHeading = document.createElement('h2');
      returnClaimDetailsHeading.textContent = 'Return Claim Details';
      shadow.querySelector('form > *:nth-child(17)').after(returnClaimDetailsHeading);

      const attachmentsHeading = document.createElement('h2');
      attachmentsHeading.textContent = 'Attachments';
      shadow.querySelector('form > *:nth-child(21)').after(attachmentsHeading);
      
      const acknowledgementsHeading = document.createElement('h2');
      acknowledgementsHeading.textContent = 'Return/Claim Process Acknowledgements';
      shadow.querySelector('form > *:nth-child(24)').after(acknowledgementsHeading);

      formContainer.classList.add('loaded');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});